export const PLATE_CHANGE_PASSWORD = 'plate-change-password'
export const ERROR_REPORT = 'error-report'
export const LOW_BALANCE_OFFER = 'low-balance-offer'
export const SUBSCRIPTION_CHANGE_NOTIFICATION = 'subscription-change-notification'
export const PLATE_ADD_VOICE = 'plate-add-voice'
